/**
 * No-op frame for analysis cards on a redesigned deep-analysis page. The
 * page's DeepAnalysisLayout already provides the slot contexts (filter /
 * options docking), so the card must not wrap itself in
 * DeepAnalysisEntityFrame — that would shadow them with its own toolbar.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The card body.
 */
const DeepAnalysisPassthroughFrame = ({ children }) => <>{children}</>

export default DeepAnalysisPassthroughFrame
